export default "/images/Id_bank.png?69961c87af4559fb843cd4be851c99c6";